import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ReturnResult } from 'src/app/shared/models/return-result';
import { CampaignManagementService } from 'src/app/modules/admin/campaign-management/campaign-management.service';

export interface LookupData {
  callerId: string;
  campaignHistoryId: string;
  campaignName: string;
  subject?: string;
  timestamp: Date;
}

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss']
})
export class IframeDialogComponent implements OnInit {
  isLoading = true;
  iframeUrl: string = '';
  error: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<IframeDialogComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: LookupData,
    private campaignService: CampaignManagementService
  ) {}

  async ngOnInit() {
    try {
      await this.loadCampaignEmail();
    } catch (error) {
      console.error('Failed to load iframe URL:', error);
      this.handleError(error);
    }
  }

    async loadCampaignEmail() {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await this.campaignService.getCampaignEmail(this.data).toPromise();

      if (response  && response.result) {
        this.iframeUrl = response.result;
      } else {
        throw new Error(response?.message || 'Failed to get campaign email');
      }
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  private handleError(error: any): void {
    this.isLoading = false;
    if (error instanceof HttpErrorResponse) {
      this.error = `Server error: ${error.status} - ${error.message}`;
    } else {
      this.error = error?.message || 'An unexpected error occurred';
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onIframeLoad(): void {
    this.isLoading = false;
  }
} 